// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* PuzzleSettings.css */

/* Оверлей для фона */
.puzzle-settings-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* Полупрозрачный черный */
  z-index: 1050; /* Ниже меню, но выше остального контента */
  cursor: pointer;
}

/* Контейнер меню */
.puzzle-settings-menu {
  position: absolute;
  /* Позиционирование относительно CanvasPuzzleBoard */
  /* Например, сверху по центру под заголовком */
  top: 50px; /* Отрегулируй по месту */
  left: 50%;
  transform: translateX(-50%);
  width: 90%; /* Ширина меню */
  max-width: 320px; /* Максимальная ширина */
  background-color: rgba(40, 40, 40, 0.9); /* Темный полупрозрачный фон */
  color: #f0f0f0; /* Светлый текст */
  border-radius: 8px;
  padding: 15px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
  z-index: 1060; /* Выше оверлея */
  display: flex;
  flex-direction: column;
  gap: 15px; /* Промежуток между элементами */
}

/* Импортируем стили кнопок из Buttons.css */
.puzzle-settings-menu .button-row {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

/* Общие стили для всех кнопок */
.puzzle-settings-menu .wide-button,
.puzzle-settings-menu .small-button,
.puzzle-settings-menu .small-red-button,
.toggle-button {
  font-size: 14px;
  border: none;
  padding: 8px 15px;
  border-radius: 8px;
  margin: 0;
  cursor: pointer;
  text-align: center;
}

/* Широкая кнопка (синяя) */
.puzzle-settings-menu .wide-button {
  width: 100%;
  background-color: var(--tg-theme-button-color, #007bff);
  color: var(--tg-theme-button-text-color, white);
}

/* Узкая кнопка (синяя) */
.puzzle-settings-menu .small-button {
  width: 48%;
  background-color: var(--tg-theme-button-color, #007bff);
  color: var(--tg-theme-button-text-color, white);
}

/* Красная кнопка */
.puzzle-settings-menu .small-red-button {
  width: 48%;
  background-color: var(--tg-theme-destructive-text-color, #dc3545);
  color: var(--tg-theme-button-text-color, white);
}

/* Эффект наведения для всех кнопок */
.puzzle-settings-menu .wide-button:hover,
.puzzle-settings-menu .small-button:hover,
.puzzle-settings-menu .small-red-button:hover,
.toggle-button:hover {
  opacity: 0.9;
}

/* Стили для заголовка и переключателей категорий */
.puzzle-settings-header {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 5px;
}

.puzzle-settings-title {
  text-align: center;
  margin: 0 0 5px 0;
  font-size: 16px;
  color: #ffffff; /* Белый заголовок */
  font-weight: bold;
}

/* Стили для переключателей категорий */
.puzzle-category-switcher {
  display: flex;
  justify-content: center;
  gap: 5px;
  padding: 5px 0;
  width: 100%;
}

.puzzle-category-btn {
  flex-grow: 1;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  cursor: pointer;
  color: white;
  background: #444;
  border: none;
  font-size: 14px;
  transition: background-color 0.2s ease, color 0.2s ease;
}

.puzzle-category-btn.active {
  background: var(--tg-theme-button-color, #007bff);
  color: var(--tg-theme-button-text-color, white);
}

/* Контент категории */
.puzzle-settings-content {
  width: 100%;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.puzzle-settings-list {
  display: flex;
  flex-direction: column;
  gap: 12px; /* Промежуток между настройками */
  width: 100%;
}

/* Общий стиль для элемента настройки */
.puzzle-setting-item {
  display: flex;
  flex-direction: column;
  gap: 6px; /* Промежуток между label и контролом */
}

.puzzle-setting-item label {
  font-size: 13px;
  color: #cccccc; /* Светло-серый для меток */
  margin-bottom: 2px;
}

/* Стили для слайдера */
.puzzle-slider {
  appearance: none;
  width: 100%;
  height: 6px;
  background: #555; /* Фон трека */
  border-radius: 3px;
  cursor: pointer;
  outline: none;
}

/* Обычный синий ползунок */
.puzzle-slider::-webkit-slider-thumb {
  appearance: none;
  width: 16px;
  height: 16px;
  background: #007bff; /* Синий ползунок */
  border-radius: 50%;
  cursor: pointer;
  -webkit-transition: background-color 0.5s ease;
  transition: background-color 0.5s ease;
}

.puzzle-slider::-moz-range-thumb {
  width: 16px;
  height: 16px;
  background: #007bff;
  border-radius: 50%;
  cursor: pointer;
  border: none;
  -moz-transition: background-color 0.5s ease;
  transition: background-color 0.5s ease;
}

/* Красный ползунок для расширенного диапазона */
.puzzle-slider.expanded-range::-webkit-slider-thumb {
  background: #dc3545; /* Красный ползунок */
  -webkit-transition: background-color 0.5s ease;
  transition: background-color 0.5s ease;
}

.puzzle-slider.expanded-range::-moz-range-thumb {
  background: #dc3545; /* Красный ползунок */
  -moz-transition: background-color 0.5s ease;
  transition: background-color 0.5s ease;
}

.puzzle-slider.default-range::-webkit-slider-thumb {
  background: #1ea229; /* Синий ползунок */
  -webkit-transition: background-color 0.5s ease;
  transition: background-color 0.5s ease;
}

.puzzle-slider.default-range::-moz-range-thumb {
  background: #1ea229; /* Синий ползунок */
  -moz-transition: background-color 0.5s ease;
  transition: background-color 0.5s ease;
}

/* Стили для переключателя (кнопок) */
.toggle-buttons {
  display: flex;
  gap: 8px;
}

/* Серая кнопка с обводкой (невыбранный тумблер) */
.toggle-button {
  flex-grow: 1;
  background-color: #444;
  color: #ccc;
  transition: background-color 0.2s ease, color 0.2s ease;
}

/* Синяя кнопка (выбранный тумблер) */
.toggle-button.active {
  background-color: var(--tg-theme-button-color, #007bff);
  color: white;
  border: none;
}


/* <<< Стили для колорпикера и индикатора >>> */

/* Стили для элемента выбора цвета */
.color-item .puzzle-settings-label {
  padding: 5px 0; /* Небольшой отступ для кликабельной области */
}

.puzzle-color-indicator {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  margin-right: 10px;
  box-shadow: 0 0 0 0.5px rgba(0, 0, 0, 0.3), 0 0 0 1px rgba(150, 150, 150, 0.3); /* Тень */
  display: inline-block;
  vertical-align: middle;
  flex-shrink: 0;
}

/* Контейнер колорпикера */
.puzzle-color-picker-container {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1070; /* Выше основного меню и его оверлея */
  background-color: rgba(50, 50, 50, 0.95);
  padding: 15px;
  border-radius: 8px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.4);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.puzzle-color-picker-container .react-colorful {
  width: 250px;
  height: 200px;
}

.puzzle-color-picker-container .react-colorful__hue,
.puzzle-color-picker-container .react-colorful__alpha {
  height: 15px;
  border-radius: 3px;
}

.puzzle-color-picker-container .react-colorful__hue-pointer,
.puzzle-color-picker-container .react-colorful__alpha-pointer {
  width: 18px;
  height: 18px;
}

.puzzle-color-picker-container .react-colorful__saturation-pointer {
    width: 18px;
    height: 18px;
}

/* Оверлей для пикера */
.picker-overlay {
  z-index: 1065; /* Выше основного меню, ниже пикера */
  background-color: rgba(0, 0, 0, 0.3);
}

/* Кнопка "Применить" для пикера */
.picker-apply-button {
  width: 100%;
  font-size: 14px;
  border: none;
  padding: 8px 15px;
  border-radius: 8px;
  background-color: var(--tg-theme-button-color, #007bff);
  color: var(--tg-theme-button-text-color, white);
  cursor: pointer;
  transition: opacity 0.2s ease;
  margin-top: 10px;
  text-align: center;
}

.picker-apply-button:hover {
  opacity: 0.9;
}



/* Сообщение, когда настройки недоступны */
.puzzle-settings-owner-only {
  padding: 3px;
  text-align: center;
  color: #aaa;
  font-style: italic;
  border-radius: 8px;
  background-color: rgba(0, 0, 0, 0.2);
}


.puzzle-settings-read-only-list {
  border-top: 1px solid #eee; /* Небольшой разделитель */
  color: #bfbfbf; /* Чуть менее яркий текст */
}

.puzzle-settings-read-only-list h4 {
  margin-bottom: 8px;
  font-size: 1em;
  color: #b8b8b8;
  font-weight: 600;
}

.puzzle-setting-read-only-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 3px 0;
  font-size: 0.85em;
}

.puzzle-setting-read-only-label {
  margin-right: 5px;
  white-space: nowrap;
}

.puzzle-setting-read-only-value {
  font-weight: 500;
  text-align: right;
}



`, "",{"version":3,"sources":["webpack://./src/components/canvaspuzzle/components/menu/PuzzleSettings.css"],"names":[],"mappings":"AAAA,uBAAuB;;AAEvB,qBAAqB;AACrB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC,EAAE,0BAA0B;EAChE,aAAa,EAAE,2CAA2C;EAC1D,eAAe;AACjB;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,oDAAoD;EACpD,8CAA8C;EAC9C,SAAS,EAAE,yBAAyB;EACpC,SAAS;EACT,2BAA2B;EAC3B,UAAU,EAAE,gBAAgB;EAC5B,gBAAgB,EAAE,wBAAwB;EAC1C,uCAAuC,EAAE,8BAA8B;EACvE,cAAc,EAAE,kBAAkB;EAClC,kBAAkB;EAClB,aAAa;EACb,yCAAyC;EACzC,aAAa,EAAE,iBAAiB;EAChC,aAAa;EACb,sBAAsB;EACtB,SAAS,EAAE,gCAAgC;AAC7C;;AAEA,4CAA4C;AAC5C;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;AACb;;AAEA,gCAAgC;AAChC;;;;EAIE,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;EACT,eAAe;EACf,kBAAkB;AACpB;;AAEA,2BAA2B;AAC3B;EACE,WAAW;EACX,uDAAuD;EACvD,+CAA+C;AACjD;;AAEA,yBAAyB;AACzB;EACE,UAAU;EACV,uDAAuD;EACvD,+CAA+C;AACjD;;AAEA,mBAAmB;AACnB;EACE,UAAU;EACV,iEAAiE;EACjE,+CAA+C;AACjD;;AAEA,qCAAqC;AACrC;;;;EAIE,YAAY;AACd;;AAEA,mDAAmD;AACnD;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,cAAc,EAAE,oBAAoB;EACpC,iBAAiB;AACnB;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,cAAc;EACd,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,uDAAuD;AACzD;;AAEA;EACE,iDAAiD;EACjD,+CAA+C;AACjD;;AAEA,sBAAsB;AACtB;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS,EAAE,iCAAiC;EAC5C,WAAW;AACb;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ,EAAE,uCAAuC;AACnD;;AAEA;EACE,eAAe;EACf,cAAc,EAAE,2BAA2B;EAC3C,kBAAkB;AACpB;;AAEA,uBAAuB;AACvB;EAEE,gBAAgB;EAChB,WAAW;EACX,WAAW;EACX,gBAAgB,EAAE,cAAc;EAChC,kBAAkB;EAClB,eAAe;EACf,aAAa;AACf;;AAEA,2BAA2B;AAC3B;EAEE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,mBAAmB,EAAE,mBAAmB;EACxC,kBAAkB;EAClB,eAAe;EACf,8CAAsC;EAAtC,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,2CAAsC;EAAtC,sCAAsC;AACxC;;AAEA,gDAAgD;AAChD;EACE,mBAAmB,EAAE,qBAAqB;EAC1C,8CAAsC;EAAtC,sCAAsC;AACxC;;AAEA;EACE,mBAAmB,EAAE,qBAAqB;EAC1C,2CAAsC;EAAtC,sCAAsC;AACxC;;AAEA;EACE,mBAAmB,EAAE,mBAAmB;EACxC,8CAAsC;EAAtC,sCAAsC;AACxC;;AAEA;EACE,mBAAmB,EAAE,mBAAmB;EACxC,2CAAsC;EAAtC,sCAAsC;AACxC;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,QAAQ;AACV;;AAEA,kDAAkD;AAClD;EACE,YAAY;EACZ,sBAAsB;EACtB,WAAW;EACX,uDAAuD;AACzD;;AAEA,qCAAqC;AACrC;EACE,uDAAuD;EACvD,YAAY;EACZ,YAAY;AACd;;;AAGA,+CAA+C;;AAE/C,oCAAoC;AACpC;EACE,cAAc,EAAE,8CAA8C;AAChE;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,8EAA8E,EAAE,SAAS;EACzF,qBAAqB;EACrB,sBAAsB;EACtB,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,aAAa,EAAE,sCAAsC;EACrD,wCAAwC;EACxC,aAAa;EACb,kBAAkB;EAClB,yCAAyC;EACzC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;;EAEE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA,uBAAuB;AACvB;EACE,aAAa,EAAE,qCAAqC;EACpD,oCAAoC;AACtC;;AAEA,kCAAkC;AAClC;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,uDAAuD;EACvD,+CAA+C;EAC/C,eAAe;EACf,6BAA6B;EAC7B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;;;AAIA,0CAA0C;AAC1C;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,oCAAoC;AACtC;;;AAGA;EACE,0BAA0B,EAAE,0BAA0B;EACtD,cAAc,EAAE,2BAA2B;AAC7C;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB","sourcesContent":["/* PuzzleSettings.css */\r\n\r\n/* Оверлей для фона */\r\n.puzzle-settings-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background-color: rgba(0, 0, 0, 0.5); /* Полупрозрачный черный */\r\n  z-index: 1050; /* Ниже меню, но выше остального контента */\r\n  cursor: pointer;\r\n}\r\n\r\n/* Контейнер меню */\r\n.puzzle-settings-menu {\r\n  position: absolute;\r\n  /* Позиционирование относительно CanvasPuzzleBoard */\r\n  /* Например, сверху по центру под заголовком */\r\n  top: 50px; /* Отрегулируй по месту */\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  width: 90%; /* Ширина меню */\r\n  max-width: 320px; /* Максимальная ширина */\r\n  background-color: rgba(40, 40, 40, 0.9); /* Темный полупрозрачный фон */\r\n  color: #f0f0f0; /* Светлый текст */\r\n  border-radius: 8px;\r\n  padding: 15px;\r\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);\r\n  z-index: 1060; /* Выше оверлея */\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 15px; /* Промежуток между элементами */\r\n}\r\n\r\n/* Импортируем стили кнопок из Buttons.css */\r\n.puzzle-settings-menu .button-row {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  width: 100%;\r\n}\r\n\r\n/* Общие стили для всех кнопок */\r\n.puzzle-settings-menu .wide-button,\r\n.puzzle-settings-menu .small-button,\r\n.puzzle-settings-menu .small-red-button,\r\n.toggle-button {\r\n  font-size: 14px;\r\n  border: none;\r\n  padding: 8px 15px;\r\n  border-radius: 8px;\r\n  margin: 0;\r\n  cursor: pointer;\r\n  text-align: center;\r\n}\r\n\r\n/* Широкая кнопка (синяя) */\r\n.puzzle-settings-menu .wide-button {\r\n  width: 100%;\r\n  background-color: var(--tg-theme-button-color, #007bff);\r\n  color: var(--tg-theme-button-text-color, white);\r\n}\r\n\r\n/* Узкая кнопка (синяя) */\r\n.puzzle-settings-menu .small-button {\r\n  width: 48%;\r\n  background-color: var(--tg-theme-button-color, #007bff);\r\n  color: var(--tg-theme-button-text-color, white);\r\n}\r\n\r\n/* Красная кнопка */\r\n.puzzle-settings-menu .small-red-button {\r\n  width: 48%;\r\n  background-color: var(--tg-theme-destructive-text-color, #dc3545);\r\n  color: var(--tg-theme-button-text-color, white);\r\n}\r\n\r\n/* Эффект наведения для всех кнопок */\r\n.puzzle-settings-menu .wide-button:hover,\r\n.puzzle-settings-menu .small-button:hover,\r\n.puzzle-settings-menu .small-red-button:hover,\r\n.toggle-button:hover {\r\n  opacity: 0.9;\r\n}\r\n\r\n/* Стили для заголовка и переключателей категорий */\r\n.puzzle-settings-header {\r\n  width: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  margin-bottom: 5px;\r\n}\r\n\r\n.puzzle-settings-title {\r\n  text-align: center;\r\n  margin: 0 0 5px 0;\r\n  font-size: 16px;\r\n  color: #ffffff; /* Белый заголовок */\r\n  font-weight: bold;\r\n}\r\n\r\n/* Стили для переключателей категорий */\r\n.puzzle-category-switcher {\r\n  display: flex;\r\n  justify-content: center;\r\n  gap: 5px;\r\n  padding: 5px 0;\r\n  width: 100%;\r\n}\r\n\r\n.puzzle-category-btn {\r\n  flex-grow: 1;\r\n  padding: 4px 10px;\r\n  border-radius: 12px;\r\n  font-size: 12px;\r\n  cursor: pointer;\r\n  color: white;\r\n  background: #444;\r\n  border: none;\r\n  font-size: 14px;\r\n  transition: background-color 0.2s ease, color 0.2s ease;\r\n}\r\n\r\n.puzzle-category-btn.active {\r\n  background: var(--tg-theme-button-color, #007bff);\r\n  color: var(--tg-theme-button-text-color, white);\r\n}\r\n\r\n/* Контент категории */\r\n.puzzle-settings-content {\r\n  width: 100%;\r\n  flex-grow: 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 5px;\r\n}\r\n\r\n.puzzle-settings-list {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 12px; /* Промежуток между настройками */\r\n  width: 100%;\r\n}\r\n\r\n/* Общий стиль для элемента настройки */\r\n.puzzle-setting-item {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 6px; /* Промежуток между label и контролом */\r\n}\r\n\r\n.puzzle-setting-item label {\r\n  font-size: 13px;\r\n  color: #cccccc; /* Светло-серый для меток */\r\n  margin-bottom: 2px;\r\n}\r\n\r\n/* Стили для слайдера */\r\n.puzzle-slider {\r\n  -webkit-appearance: none;\r\n  appearance: none;\r\n  width: 100%;\r\n  height: 6px;\r\n  background: #555; /* Фон трека */\r\n  border-radius: 3px;\r\n  cursor: pointer;\r\n  outline: none;\r\n}\r\n\r\n/* Обычный синий ползунок */\r\n.puzzle-slider::-webkit-slider-thumb {\r\n  -webkit-appearance: none;\r\n  appearance: none;\r\n  width: 16px;\r\n  height: 16px;\r\n  background: #007bff; /* Синий ползунок */\r\n  border-radius: 50%;\r\n  cursor: pointer;\r\n  transition: background-color 0.5s ease;\r\n}\r\n\r\n.puzzle-slider::-moz-range-thumb {\r\n  width: 16px;\r\n  height: 16px;\r\n  background: #007bff;\r\n  border-radius: 50%;\r\n  cursor: pointer;\r\n  border: none;\r\n  transition: background-color 0.5s ease;\r\n}\r\n\r\n/* Красный ползунок для расширенного диапазона */\r\n.puzzle-slider.expanded-range::-webkit-slider-thumb {\r\n  background: #dc3545; /* Красный ползунок */\r\n  transition: background-color 0.5s ease;\r\n}\r\n\r\n.puzzle-slider.expanded-range::-moz-range-thumb {\r\n  background: #dc3545; /* Красный ползунок */\r\n  transition: background-color 0.5s ease;\r\n}\r\n\r\n.puzzle-slider.default-range::-webkit-slider-thumb {\r\n  background: #1ea229; /* Синий ползунок */\r\n  transition: background-color 0.5s ease;\r\n}\r\n\r\n.puzzle-slider.default-range::-moz-range-thumb {\r\n  background: #1ea229; /* Синий ползунок */\r\n  transition: background-color 0.5s ease;\r\n}\r\n\r\n/* Стили для переключателя (кнопок) */\r\n.toggle-buttons {\r\n  display: flex;\r\n  gap: 8px;\r\n}\r\n\r\n/* Серая кнопка с обводкой (невыбранный тумблер) */\r\n.toggle-button {\r\n  flex-grow: 1;\r\n  background-color: #444;\r\n  color: #ccc;\r\n  transition: background-color 0.2s ease, color 0.2s ease;\r\n}\r\n\r\n/* Синяя кнопка (выбранный тумблер) */\r\n.toggle-button.active {\r\n  background-color: var(--tg-theme-button-color, #007bff);\r\n  color: white;\r\n  border: none;\r\n}\r\n\r\n\r\n/* <<< Стили для колорпикера и индикатора >>> */\r\n\r\n/* Стили для элемента выбора цвета */\r\n.color-item .puzzle-settings-label {\r\n  padding: 5px 0; /* Небольшой отступ для кликабельной области */\r\n}\r\n\r\n.puzzle-color-indicator {\r\n  width: 30px;\r\n  height: 30px;\r\n  border-radius: 50%;\r\n  margin-right: 10px;\r\n  box-shadow: 0 0 0 0.5px rgba(0, 0, 0, 0.3), 0 0 0 1px rgba(150, 150, 150, 0.3); /* Тень */\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n  flex-shrink: 0;\r\n}\r\n\r\n/* Контейнер колорпикера */\r\n.puzzle-color-picker-container {\r\n  position: fixed;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  z-index: 1070; /* Выше основного меню и его оверлея */\r\n  background-color: rgba(50, 50, 50, 0.95);\r\n  padding: 15px;\r\n  border-radius: 8px;\r\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.4);\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 10px;\r\n}\r\n\r\n.puzzle-color-picker-container .react-colorful {\r\n  width: 250px;\r\n  height: 200px;\r\n}\r\n\r\n.puzzle-color-picker-container .react-colorful__hue,\r\n.puzzle-color-picker-container .react-colorful__alpha {\r\n  height: 15px;\r\n  border-radius: 3px;\r\n}\r\n\r\n.puzzle-color-picker-container .react-colorful__hue-pointer,\r\n.puzzle-color-picker-container .react-colorful__alpha-pointer {\r\n  width: 18px;\r\n  height: 18px;\r\n}\r\n\r\n.puzzle-color-picker-container .react-colorful__saturation-pointer {\r\n    width: 18px;\r\n    height: 18px;\r\n}\r\n\r\n/* Оверлей для пикера */\r\n.picker-overlay {\r\n  z-index: 1065; /* Выше основного меню, ниже пикера */\r\n  background-color: rgba(0, 0, 0, 0.3);\r\n}\r\n\r\n/* Кнопка \"Применить\" для пикера */\r\n.picker-apply-button {\r\n  width: 100%;\r\n  font-size: 14px;\r\n  border: none;\r\n  padding: 8px 15px;\r\n  border-radius: 8px;\r\n  background-color: var(--tg-theme-button-color, #007bff);\r\n  color: var(--tg-theme-button-text-color, white);\r\n  cursor: pointer;\r\n  transition: opacity 0.2s ease;\r\n  margin-top: 10px;\r\n  text-align: center;\r\n}\r\n\r\n.picker-apply-button:hover {\r\n  opacity: 0.9;\r\n}\r\n\r\n\r\n\r\n/* Сообщение, когда настройки недоступны */\r\n.puzzle-settings-owner-only {\r\n  padding: 3px;\r\n  text-align: center;\r\n  color: #aaa;\r\n  font-style: italic;\r\n  border-radius: 8px;\r\n  background-color: rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n\r\n.puzzle-settings-read-only-list {\r\n  border-top: 1px solid #eee; /* Небольшой разделитель */\r\n  color: #bfbfbf; /* Чуть менее яркий текст */\r\n}\r\n\r\n.puzzle-settings-read-only-list h4 {\r\n  margin-bottom: 8px;\r\n  font-size: 1em;\r\n  color: #b8b8b8;\r\n  font-weight: 600;\r\n}\r\n\r\n.puzzle-setting-read-only-item {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 3px 0;\r\n  font-size: 0.85em;\r\n}\r\n\r\n.puzzle-setting-read-only-label {\r\n  margin-right: 5px;\r\n  white-space: nowrap;\r\n}\r\n\r\n.puzzle-setting-read-only-value {\r\n  font-weight: 500;\r\n  text-align: right;\r\n}\r\n\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
